<template>
    <div class="tab-links">
        <div class="links-block">
            <div class="links-title">{{ $t("AttachedURLs") }}</div>
            <ul v-if="linksList.length > 0" class="list-content">
                <li v-for="(item, index) in linksList" :key="`link-${index}`" :itemId="item.id">
                    <a target="_blank" @click="openUrl(item)" class="link-doc" :class="{ clicked: item.isClicked }">
                        <div>
                            <UrlIcon />
                        </div>

                        <span :id="`tooltip-link-${index}`">{{ item.name }}</span>


                    </a>
                </li>
            </ul>
            <div v-else class="no-links-block">
                <div class="no-links">
                    <UrlIcon class="no-url-icon" />
                    <p class="title">{{ $t("NoLinkTitle") }}</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapMutations } from "vuex";
import UrlIcon from "@core/assets/icons/url-icon.svg";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        UrlIcon,
        ToastificationContent
    },
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        linksList() {
            return this.list.filter((item) => item.type === "Link");
        }
    },
    mounted() {
        this.UPDATE_FLAG_SHOW_OVERLAY(false);
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        openUrl(item) {
            this.$set(item, "isClicked", true);

            const isLocalPath = /^[a-zA-Z]:\\|^\\\\/.test(item.url);

            if (isLocalPath) {
                navigator.clipboard.writeText(item.url).then(() => {
                    this.showToast(this.$t("ProductionProgress.Success"), "FrownIcon", `Caminho copiado: "${item.url}"\n\n. Cole o endereço no seu Explorador de Arquivos.`, "success");
                }).catch(err => {
                    console.error('Erro ao copiar: ', err);
                });

                return;
            }

            const finalUrl = /^https?:\/\//i.test(item.url) ? item.url : 'https://' + item.url;
            window.open(finalUrl, "_blank", "noopener,noreferrer");
        },
        showToast(title, icon, text, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title,
                    icon,
                    text,
                    variant
                }
            });
        },
    }
};
</script>
<style lang="scss">
.tooltip-link {
    z-index: 99999999;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}
</style>
<style lang="scss" scoped>
.tab-links {
    flex-grow: 1;
    height: 100%;

    li {
        height: 82px;
        display: flex;
        align-items: center;
        padding: 0 29px;
        border-bottom: 1px solid #cfc4be;
        user-select: none;
        cursor: pointer;

        .link-doc {
            display: flex;
            align-items: center;
            gap: 20px;
            max-width: 100%;

            &.clicked {
                span {
                    color: #998f8a !important;
                }
            }

            span {
                font-size: 14px;
                line-height: 20px;
                font-weight: 400;
                color: #974900;
                word-break: break-all;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            svg {
                width: 20px;
                height: 20px;
                fill: #4c4541;
            }
        }
    }

    .links-block {
        max-height: 318px;
        height: 100%;
        overflow: auto;

        .links-title {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
            /* 162.5% */
            padding: 16px 0 4px 29px;
        }

        &::-webkit-scrollbar {
            width: 16px;
        }

        &::-webkit-scrollbar-track {
            background: #fff;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #cfc4be;
            border-radius: 20px;
            border: 4px solid #fff;
            height: 70px;
        }
    }

    .no-links-block {
        max-height: 298px;
        height: 100%;

        .no-links {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            margin: 0 16px;
            max-height: 298px;
            height: 100%;

            .no-url-icon {
                fill: #998f8a;
                width: 80px;
                height: 80px;
            }

            .title {
                padding-top: 12px;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
                color: #4c4541;
                margin: 0;
            }

            @media (max-width: 480px) {

                    .no-url-icon {
                    width: 40px;
                    height: 40px;
                }

                .title {
                    font-size: 14px;
                }
            }
        }
    }

    .list-content {
        &::-webkit-scrollbar {
            width: 16px;
        }

        &::-webkit-scrollbar-track {
            background: #fff;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #cfc4be;
            border-radius: 20px;
            border: 4px solid #fff;
            height: 70px;
        }

        overflow: auto;
        padding: 0;
        margin: 0;
    }
}

@media (max-width: 768px) {
    .tab-links {

        .links-block .links-title {
            font-size: 22px;
            line-height: 30px;
        }

        li {
            .link-doc {
                span {
                    font-size: 22px;
                }

                svg {
                    width: 34px;
                    height: 34px;
                }
            }
        }
    }
}

@media (max-width: 425px) {
    .tab-links {

        .links-block .links-title {
            font-size: 14px;
            line-height: 20px;
            /* 142.857% */
            padding: 12px 0 4px 16px;
        }

        li {
            padding: 0 16px;
            height: 72px;

            .link-doc {
                span {
                    font-size: 14px;
                }

                svg {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }
}
</style>
